var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"image-rotator"}},[_c('img',{attrs:{"src":_vm.paths[_vm.pathIndex],"width":_vm.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }